"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fbIcon = require('../../images/pages/footer-facebook-icon.png');

var instagramIcon = require('../../images/pages/footer-instagram-icon.png');

var twitterIcon = require('../../images/pages/footer-twitter-icon.png');

var linkedInIcon = require('../../images/pages/footer-linked-in-icon.png');

require('../../sass/components/pages/PageFooter.css');

var _default = function _default(_ref) {
  var _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? 'home' : _ref$currentPage,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass;
  var currentYear = new Date().getFullYear();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('page-footer', customClass)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "everdays-copyright"
  }, "\xA9 Everdays ", currentYear), /*#__PURE__*/_react.default.createElement("div", {
    className: "social-icons"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.facebook.com/JoinEverdays/",
    className: "social-media-link",
    target: "_blank",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_facebook"))
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: fbIcon
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.instagram.com/everdayslife/",
    className: "social-media-link",
    target: "_blank",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_instagram"))
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: instagramIcon
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://twitter.com/everdaysapp",
    className: "social-media-link",
    target: "_blank",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_twitter"))
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: twitterIcon
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.linkedin.com/company/everdays-inc./",
    className: "social-media-link",
    target: "_blank",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_linkedin"))
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: linkedInIcon
  }))));
};

exports.default = _default;